import React from 'react';
import ImagenSpc from './ImagenSpc';

/*
  Sistema de ensamblado + tutorial de cortar y conectar paneles.
  Se renderiza después del video en la página de Piso SPC Premium.
  El título y la introducción (con la info de Unilin Click integrada en el texto) son los textos
  existentes del antiguo bloque de ensamblado; solo los pies de cada paso y los títulos de grupo
  son nuevos (borrador).

  Imágenes (en /public/assets/img/productos/pisos-spc-premium/instalacion/):
    corte-1.jpg … corte-4.jpg  |  ensamble-1.jpg … ensamble-4.jpg
*/
const RUTA = '/assets/img/productos/pisos-spc-premium';

const CORTE = [
  { img: 'corte-1.jpg', w: 626, h: 400, alt: 'Corte de un panel con cúter, paso 1', texto: 'Marca la línea de corte con un cúter.' },
  { img: 'corte-2.jpg', w: 642, h: 400, alt: 'Corte de un panel con cúter, paso 2', texto: 'Repasa la marca para profundizar el corte.' },
  { img: 'corte-3.jpg', w: 634, h: 400, alt: 'Panel doblado sobre la marca de corte, paso 3', texto: 'Dobla el panel para separarlo.' },
  { img: 'corte-4.jpg', w: 640, h: 400, alt: 'Panel cortado a la medida, paso 4', texto: 'El panel queda a la medida.' },
];

const ENSAMBLE = [
  { img: 'ensamble-1.jpg', w: 578, h: 548, lado: 'Lado largo', alt: 'Lado largo: perfil del borde del panel antes de unirse, paso 1', texto: 'Alinea e inserta el borde del panel.' },
  { img: 'ensamble-2.jpg', w: 580, h: 548, lado: 'Lado largo', alt: 'Lado largo: paneles encajados, paso 2', texto: 'Baja el panel hasta que quede al ras.' },
  { img: 'ensamble-3.jpg', w: 574, h: 548, lado: 'Lado corto', alt: 'Lado corto: presionar hacia abajo para unir, paso 3', texto: 'Presiona hacia abajo para unir el extremo.' },
  { img: 'ensamble-4.jpg', w: 578, h: 548, lado: 'Lado corto', alt: 'Lado corto: panel conectado con un clic, paso 4', texto: 'Se escucha el clic: panel conectado.' },
];

const Pasos = ({ pasos, variante }) => (
  <ol className={`spc-steps spc-steps--${variante}`}>
    {pasos.map(({ img, w, h, alt, texto, lado }, i) => (
      <li className="spc-step" key={img}>
        <figure className="spc-step__fig">
          <ImagenSpc src={`${RUTA}/instalacion/${img}`} alt={alt} width={w} height={h} loading="lazy" />
          <span className="spc-step__n" aria-hidden="true">{i + 1}</span>
        </figure>
        {lado && <span className="spc-step__tag">{lado}</span>}
        <p className="spc-step__txt">{texto}</p>
      </li>
    ))}
  </ol>
);

const PasosInstalacionSpcPremium = () => {
  return (
    <div id="instalacion" className="spc-install">
      <div className="spc-install__head wow fadeIn" data-wow-delay="200ms">
        <span className="sub-title">Instalación fácil</span>
        <h3 className="h2 font-weight-800 mb-3">Sistema de ensamblado del Piso SPC Luxury</h3>
        <p className="mb-0">
          Cada detalle del Piso SPC Luxury está pensado para instalarse fácilmente y ofrecer comodidad y durabilidad. Con el sistema de ensamblado <strong>Unilin Click</strong>, una tecnología de bloqueo que une cada panel con un clic seguro, la instalación es rápida y el desmontaje, sencillo.
        </p>
      </div>

      <div className="spc-install__group">
        <h4 className="spc-install__group-title">Cómo cortar los paneles</h4>
        <Pasos pasos={CORTE} variante="cut" />
      </div>

      <div className="spc-install__group">
        <h4 className="spc-install__group-title">Cómo conectar los paneles</h4>
        <Pasos pasos={ENSAMBLE} variante="connect" />
      </div>
    </div>
  );
};

export default PasosInstalacionSpcPremium;